export default __webpack_public_path__ + "static/media/primary_logo.99e6f44e.png";